module.exports = "/_next/static/images/SFLogo-b3f6eda3b4e5a109b0db6e9a223c5be7.png";